export default __webpack_public_path__ + "static/media/error-icon.cf4fa721.svg";